import { alpha, Box, Typography } from '@mui/material';
import { isValidElement } from 'react';

export function CaptionedImage({
  imageSrc,
  topCaption,
  bottomCaption,
  height,
  width,
  fallbackWidth,
  fallbackHeight,
  lockDimension = 'height',
  borderRadius = 1,
  alt,
  topCaptionProps,
  bottomCaptionProps,
}) {
  return (
    <Box
      sx={(theme) => ({
        position: 'relative',
        borderRadius,
        bgcolor: theme.palette.mode === 'dark' ? 'grey.600' : 'grey.300',
        overflow: 'hidden',
        height:
          lockDimension === 'width'
            ? imageSrc
              ? undefined
              : fallbackHeight
            : height,
        width:
          lockDimension === 'height'
            ? imageSrc
              ? undefined
              : fallbackWidth
            : width,
        flexShrink: 0,
      })}
    >
      {imageSrc ? (
        <img
          src={imageSrc}
          alt={alt}
          height={height}
          width={width}
          style={{ display: 'block' }}
        />
      ) : (
        <Box
          sx={(theme) => ({
            height: height ?? fallbackHeight,
            width: width ?? fallbackWidth,
            bgcolor: theme.palette.mode === 'dark' ? 'grey.600' : 'grey.300',
          })}
        />
      )}
      {topCaption && (
        <Box
          sx={(theme) => ({
            position: 'absolute',
            top: 0,
            width: 1,
            color: 'white',
            bgcolor: alpha(theme.palette.common.black, 0.75),
            padding: 1,
          })}
        >
          {isValidElement(topCaption) ? (
            topCaption
          ) : (
            <Typography {...topCaptionProps}>{topCaption}</Typography>
          )}
        </Box>
      )}
      {bottomCaption && (
        <Box
          sx={(theme) => ({
            position: 'absolute',
            bottom: 0,
            width: 1,
            color: 'white',
            bgcolor: alpha(theme.palette.common.black, 0.75),
            padding: 1,
          })}
        >
          {isValidElement(bottomCaption) ? (
            bottomCaption
          ) : (
            <Typography {...bottomCaptionProps}>{bottomCaption}</Typography>
          )}
        </Box>
      )}
    </Box>
  );
}
